export default __webpack_public_path__ + "static/media/1.f55b6276.png";